import styled from 'styled-components/macro'

import { Dialog, Divider, Layout, Text, type DialogProps } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { Icon } from 'core/ui/components/icon/Icon'

const StyledItem = styled.div`
  display: flex;
  gap: ${getToken('spacing-4')};
  align-items: flex-start;
`

export type AutoSubmitConfirmDialogProps = DialogProps & {
  open: boolean
  onEnable: () => void
  onCancel: () => void
}

export function AutoSubmitConfirmDialog({
  open,
  onEnable,
  onCancel,
}: AutoSubmitConfirmDialogProps) {
  return (
    <Dialog open={open} size="medium" onClose={onCancel}>
      <Dialog.Header>
        Enable auto-submit?
        <Dialog.Close />
      </Dialog.Header>
      <Dialog.Body>
        <Layout.Box borderColor="color-border" borderWidth="border-thin" padding="spacing-6">
          <Layout.Stack>
            <StyledItem>
              <Icon name="deal" size={20} />
              <Text variant="body-md">
                Loadsmart will automatically share your rates when the deadline ends.
              </Text>
            </StyledItem>
            <Divider />
            <StyledItem>
              <Icon name="attention" size={20} />
              <Text variant="body-md">
                Be aware that Shippers might close this RFP before the deadline ends and won't see
                your rates.
              </Text>
            </StyledItem>
            <Divider />
            <StyledItem>
              <Icon name="fast" size={20} />
              <Layout.Group>
                <Text variant="body-md">
                  Most carriers send their rates in the first hour after the invite.
                </Text>
                <Text variant="body-md-bold">
                  We strongly suggest you send your rates before the deadline to increase your
                  chances to win.
                </Text>
              </Layout.Group>
            </StyledItem>
          </Layout.Stack>
        </Layout.Box>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={onCancel}>Cancel</Dialog.ActionTertiary>
        <Dialog.ActionPrimary onClick={onEnable}>Enable</Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
